import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

import { Wrapper, Label, Content } from "./LabelValue";

const IconSkeleton = styled(Skeleton)({
    gridArea: "icon",
    alignSelf: "top",
    borderRadius: 12,
});

export function LabelValueSkeleton() {
    return (
        <Wrapper>
            <IconSkeleton variant="rectangular" width={24} height={24} />
            <Label>
                <Skeleton variant="rectangular" width={80} height={14} />
            </Label>
            <Content>
                <Skeleton variant="rectangular" width={120} height={22} />
            </Content>
        </Wrapper>
    );
}
